import { useNavigate } from 'react-router';
import { Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { useAppSelector } from '~/hooks';
import { fireDashboardContinueDraftClicked } from '~/posthogs/events';

// interactive link styling — no DS link component available yet
const draftLinkStyle: React.CSSProperties = {
  cursor: 'pointer',
  textDecoration: 'underline',
};

// semi-transparent card footer — no DS opacity/alpha token for this
const draftPromptBackgroundColor = `${colors.primary[500]}40`;

export const DraftPrompt = () => {
  const navigate = useNavigate();
  const draftCount = useAppSelector((state) => state.permanentJobs.draftCount);

  if (!draftCount || draftCount <= 0) return null;

  const countLabel =
    draftCount === 1
      ? '1 draft in progress'
      : `${draftCount} drafts in progress`;

  const handleContinueEditing = () => {
    fireDashboardContinueDraftClicked();
    navigate('/permanent-jobs/postings?status=draft');
  };

  return (
    <Row
      align="center"
      justify="center"
      gap={1}
      style={{ backgroundColor: draftPromptBackgroundColor, paddingBlock: 10 }}
      data-testid="draft-prompt"
    >
      <Typography size="caption" color={colors.shades['0']}>
        {countLabel} -
      </Typography>
      <Typography
        as="span"
        bold
        size="caption"
        color={colors.shades['0']}
        role="link"
        onClick={handleContinueEditing}
        style={draftLinkStyle}
        data-testid="draft-prompt-continue-editing"
      >
        Continue Editing
      </Typography>
    </Row>
  );
};
